import React from 'react';
import { useTranslation } from 'react-i18next';
import { StarPatchIcon } from 'assets/icons';
import { SelectionCard } from 'pages/TiresPage/TireReferencesSection/TireReferenceCard/TireReferenceCard.styled';
import { theme } from 'styles';
import { Flex, Icon, Text } from 'UI';

interface SelectionBadgeProps {
  visible: boolean;
}

export function SelectionBadge({ visible }: Readonly<SelectionBadgeProps>): React.JSX.Element | null {
  const { t } = useTranslation();
  if (!visible) return null;

  return (
    <SelectionCard>
      <Flex align="center" gap={10}>
        <Icon IconComponent={StarPatchIcon} size={20} color={theme.color.brand} />
        <Text type="h5_light_white" disableGutter>
          {t('catalog.tires.reference.rpartstore_selection', 'Rpartstore Selection')}
        </Text>
      </Flex>
    </SelectionCard>
  );
}
